// Egységes szerepkör-megnevezések a felületen.
// Ugyanazok a nevek, mint a Felhasználók kezelése oldalon (UserAdminView).
// Az örökölt 'user' szerepkör a szerveren szerkesztőnek számít (rbac.normalizeRole),
// ezért a felületen is annak kell látszania – korábban „Látogató” lett belőle.

export function normalizeUiRole(r?: string | null): string {
  if (!r) return 'public';
  if (r === 'user') return 'editor';
  return r;
}

const LABELS: Record<string, string> = {
  superadmin: 'Szuperadmin',
  tenant_admin: 'Szuperadmin',
  org_admin: 'Szervezeti admin',
  editor: 'Szerkesztő',
  operator: 'Ügyintéző',
  recorder: 'Ügyintéző',
  auditor: 'Auditor',
  public: 'Látogató',
};

export function roleLabel(r?: string | null): string {
  return LABELS[normalizeUiRole(r)] || 'Látogató';
}

// A tényleges szerepkör – a szerver rbac.effectiveRole szabályával azonos:
//  - superadmin / org_admin alapszerepkört a granular_role nem érinti;
//  - egyébként a granular_role CSAK SZŰKÍTHET, emelni soha nem tud;
//  - az örökölt 'tenant_admin' csak a rendszerszervezetben (tenant 1) superadmin, máshol org_admin.
const WEIGHTS: Record<string, number> = { superadmin: 100, org_admin: 80, editor: 50, operator: 30, auditor: 20, public: 0 };

export function effectiveUiRole(u?: { role?: string | null; granular_role?: string | null; tenant_id?: number | null } | null): string {
  if (!u) return 'public';
  let base = normalizeUiRole(u.role);
  if (base === 'tenant_admin') base = Number(u.tenant_id) === 1 ? 'superadmin' : 'org_admin';
  if (base === 'superadmin' || base === 'org_admin') return base;
  const g = u.granular_role ? normalizeUiRole(u.granular_role) : null;
  if (!g) return base;
  return (WEIGHTS[g] ?? 0) < (WEIGHTS[base] ?? 0) ? g : base;
}
